module.exports = __webpack_public_path__ + "7467b9bafa36b222c9ce2ea1b2864d9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/amazon_com_2022_chart.png
// module id = 1628
// module chunks = 0